import material_model from '@/shared/models/material_model.js';

export default {
  Codigo: null,
  CodigoEspecificacionTecnica: null,
  CodigoMaterial: null,
  ItemProducto: null,
  Descripcion: null,
  Cantidad: null,
  Repeticion: null,
  Material: { ...material_model },
};
